import { render, staticRenderFns } from "./UploadPatientFromPdfButton.vue?vue&type=template&id=9af69c10"
import script from "./UploadPatientFromPdfButton.vue?vue&type=script&lang=js"
export * from "./UploadPatientFromPdfButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports